var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dsf-ac-style-spebox" },
    [
      _c("grid", {
        ref: "dsfDatagrid",
        staticStyle: { height: "100%" },
        attrs: {
          demo: _vm.demo,
          hasLoad: _vm.hasLoad,
          hasRefresh: _vm.hasRefresh,
          "http-param": _vm.childform,
          "background-color": "#fff",
          limit: _vm.limit,
          padding: _vm.padding,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (sditem) {
              return _c(
                "div",
                { key: sditem.data["nc_ztb_mhzxdata.nc_zyb_id"] },
                [
                  _c(
                    "div",
                    {
                      staticClass: "citem",
                      on: {
                        click: function ($event) {
                          return _vm.tosep(sditem)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "imgbox" },
                        [
                          _c("van-image", {
                            attrs: {
                              src: _vm.setImg(sditem.data),
                              fit: "full",
                              width: "100%",
                              height: "100%",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "loading",
                                  fn: function () {
                                    return [
                                      _c("van-loading", {
                                        attrs: { type: "spinner", size: "20" },
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "error",
                                  fn: function () {
                                    return [
                                      _c("img", {
                                        staticStyle: {
                                          width: "100%",
                                          height: "100%",
                                        },
                                        attrs: {
                                          src: require("_teas/assets/styles/themes/img/file-read-18688.png"),
                                        },
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _c("div", { staticClass: "tnum ds_font8" }, [
                            _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    sditem.data["nc_ztb_mhzxdata.pxrq_sdate"]
                                  ) +
                                  "至" +
                                  _vm._s(
                                    sditem.data["nc_ztb_mhzxdata.pxrq_edate"]
                                  ) +
                                  " "
                              ),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "rcontent" }, [
                        _c("div", { staticClass: "toptitle ds_font5_m" }, [
                          sditem.data["nc_ztb_mhzxdata.sfbx"] == 1
                            ? _c("span", { staticClass: "s2 ds_font8" }, [
                                _vm._v("必修"),
                              ])
                            : _vm._e(),
                          _c("p", { staticClass: "ell2" }, [
                            _vm._v(
                              _vm._s(sditem.data["nc_ztb_mhzxdata.title"])
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "cencontent ds_font8" }, [
                          _c("p", [
                            _vm._v(
                              " 必修: " +
                                _vm._s(
                                  sditem.data["nc_ztb_mhzxdata.bxryms"] || 0
                                ) +
                                "门 " +
                                _vm._s(
                                  sditem.data["nc_ztb_mhzxdata.bxryxs"] || 0
                                ) +
                                "学时 "
                            ),
                          ]),
                          _c("p", [
                            _vm._v(
                              " 选修: " +
                                _vm._s(
                                  sditem.data["nc_ztb_mhzxdata.xxryms"] || 0
                                ) +
                                "门 " +
                                _vm._s(
                                  sditem.data["nc_ztb_mhzxdata.xxryxs"] || 0
                                ) +
                                "学时 "
                            ),
                          ]),
                          _c("p", [
                            _vm._v(
                              "学员人数: " +
                                _vm._s(
                                  sditem.data["nc_ztb_mhzxdata.studentnum"] || 0
                                )
                            ),
                          ]),
                        ]),
                        sditem.data["nc_ztb_mhzxdata.sfwc_value"] !== 1
                          ? _c("div", {
                              staticClass: "rechart rechartno",
                              class: {
                                rechartyes:
                                  sditem.data["nc_ztb_mhzxdata.sfwc_value"] ==
                                  2,
                              },
                            })
                          : _vm._e(),
                      ]),
                    ]
                  ),
                ]
              )
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }